import { render, staticRenderFns } from "./SortiItem.vue?vue&type=template&id=1b5766d8"
import script from "./SortiItem.vue?vue&type=script&lang=ts"
export * from "./SortiItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports